import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getOpenBidsEffect = (payload) => {
  const { transportationGroup, transportationProvider } = payload;
  const url = `${API.QUOTE_DASHBOARD_V2}/open`;
  return axiosInstance.request({
    url: url,
    method: 'get',
    params: {
      CarrierKey: transportationProvider,
      TransportationGroup: transportationGroup,
    },
  });
};

export const getSevenDaysDataEffect = (payload) => {
  const { transportationGroup, transportationMode, originCountry } = payload;
  return axiosInstance.request({
    url: `${API.DASHBOARD}/GetWeeklyAwardedWeightSummary`,
    method: 'get',
    params: {
      provider: null,
      transportationGroup: transportationGroup || null,
      transportationMode: transportationMode || null,
      originCountry: originCountry || null,
    },
  });
};

export const getAwardedBidsEffect = (payload) => {
  const { transportationGroup, transportationProvider } = payload;
  const url = `${API.QUOTE_DASHBOARD_V2}/awarded`;
  return axiosInstance.request({
    url: url,
    method: 'get',
    params: {
      CarrierKey: transportationProvider,
      TransportationGroup: transportationGroup,
    },
  });
};

export const getOpenBidsAgingEffect = (payload) => {
  const { transportationGroup, transportationProvider } = payload;
  const url = `${API.QUOTE_DASHBOARD_V2}/open/ages`;
  return axiosInstance.request({
    url: url,
    method: 'get',
    params: {
      CarrierKey: transportationProvider,
      TransportationGroup: transportationGroup,
    },
  });
};

export const getOverAllTimelineEffect = (payload) => {
  const { transportationGroup, transportationProvider } = payload;
  const url = `${API.QUOTE_DASHBOARD_V2}/overall-timeline`;
  return axiosInstance.request({
    url: url,
    method: 'get',
    params: {
      CarrierKey: transportationProvider,
      TransportationGroup: transportationGroup,
    },
  });
};
